module.exports = __webpack_public_path__ + "static/media/1006126.eab94354.png";